import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/all-files/")({
  beforeLoad: () => {
    throw redirect({ to: "/files" });
  },
});
